import { SuperAdminConstants } from '../../../_constants';

const initialState = { defaultMetricListLoading: true, data: '', error: false };

export function defaultMetricListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_DEFAULT_METRIC_LIST:
            return {
                defaultMetricListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_DEFAULT_METRIC_LIST:
            return {
                defaultMetricListLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.DEFAULT_METRIC_LIST_ERROR:
            return {
                defaultMetricListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/DefineMetric/defaultMetricList.reducer.js